import { render } from "./RepeatedReportParametres.vue?vue&type=template&id=6b15d46c"
import script from "./RepeatedReportParametres.vue?vue&type=script&lang=js"
export * from "./RepeatedReportParametres.vue?vue&type=script&lang=js"

import "./RepeatedReportParametres.vue?vue&type=style&index=0&id=6b15d46c&lang=css"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__